import { bootstrapWidget } from "../../common";
import AmenitiesWidget from "./widget";

bootstrapWidget({ widget: AmenitiesWidget, widgetType: "amenities" });
